import React, { useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faUserCog,
  faDisplay,
  faXRay,
  faPersonPregnant,
} from "@fortawesome/free-solid-svg-icons";
import { NavigationLink } from "navigation-react";
import "../src/styles.css";
import { RoleContext } from "./App"; // ✅ use context instead of LS

const DashboardContenLeftMenus = () => {
  const { activeRole, permissions } = useContext(RoleContext); // ✅ get everything

  // Log active role, permissions, and roles
  useEffect(() => {
    console.log("Active Role Dashboadcontentleftmenu:", activeRole);
    console.log("Permissions Dashboadcontentleftmenu:", permissions);
  }, [activeRole, permissions]);

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>
      <ul className="menu">
        <li>
          <NavigationLink stateKey="dashboardcontent" className="menu-item">
            <FontAwesomeIcon icon={faTachometerAlt} className="menu-icon" />
            <span>Dashboard</span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink
            stateKey={
              activeRole === "requester"
                ? "ctscanrequestregister"
                : activeRole === "radiologist"
                ? "ctscanreportregister"
                : activeRole === "assigner"
                ? "ctscanassignregister"
                : "dashboardcontent"
            }
            className="menu-item"
          >
            <FontAwesomeIcon icon={faDisplay} className="menu-icon" />
            <span>CT - Scan</span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink stateKey="" className="menu-item">
            <FontAwesomeIcon icon={faXRay} className="menu-icon" />
            <span>X - Ray</span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink stateKey="" className="menu-item">
            <FontAwesomeIcon icon={faPersonPregnant} className="menu-icon" />
            <span>Ultrasound</span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink stateKey="patientregister" className="menu-item">
            <FontAwesomeIcon icon={faUsers} className="menu-icon" />
            <span>Patient</span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink stateKey="userregister" className="menu-item">
            <FontAwesomeIcon icon={faUserCog} className="menu-icon" />
            <span>Users</span>
          </NavigationLink>
        </li>
      </ul>
    </aside>
  );
};

export default DashboardContenLeftMenus;
